<div fxFlex="100" class="pdf-container">

    <!-- BOTÕES -->
    <div class="pdf-actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="12px">

        <button mat-stroked-button color="primary" (click)="dimiss()">
            <mat-icon class="mr-8">close</mat-icon>
            Fechar
        </button>

        <button mat-stroked-button color="accent" (click)="sendEMail()" [disabled]="sendingEmail">

            <!-- SPINNER -->
            <mat-progress-spinner *ngIf="sendingEmail" mode="indeterminate" diameter="18" class="mr-8">
            </mat-progress-spinner>

            <!-- ÍCONE -->
            <mat-icon *ngIf="!sendingEmail" class="mr-8">
                email
            </mat-icon>

            {{ sendingEmail ? 'Enviando...' : 'Enviar via Email' }}

        </button>

    </div>

    <!-- PDF -->
    <div class="pdf-viewer">
        <ngx-extended-pdf-viewer *ngIf="data.pdf" [base64Src]="data.pdf" enablePrintAutoRotate="true"
            [printResolution]="300" [showUnverifiedSignatures]="false" [showHandToolButton]="true"
            useBrowserLocale="true" height="100%" [zoom]="'page-width'">
        </ngx-extended-pdf-viewer>
    </div>

</div>